import moment from 'moment';
import { enableES5 } from 'immer';
import 'unorm';
import _ from 'lodash';
import 'moment/locale/hu';
import {
  SELECT_CINEMA, SELECT_WEEK,
  SELECT_DATE, SEARCH_MOVIE,
  WEEKS_AND_CINEMAS_SUCCEDED,
  WEEK_DETAILS_SUCCEDED,
  WEEK_DETAILS_REQUESTED,
  SELECT_VIEW, TABLE_REQUESTED,
  OPEN_MODAL, CLOSE_MODAL,
  CHANGE_DATE, GET_CURRENT_TIME,
  REMOVE_SEARCH_FIELD, SET_BRAND,
} from 'consts/actionTypes';
import initialState from './initialState';

enableES5();

const normalizeTitle = ({ title }) => title.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().trimStart();
const createTable = (actualMovies, state) => (actualMovies.length > 0
  ? actualMovies.map(filteredMovie => ({
    ...filteredMovie,
    schedule: Array.from(state.timeList, (time) => {
      const firstHour = moment({ hours: `${time.split('-')[0]}`, minutes: '00' });
      const secondHour = moment({ hours: `${time.split('-')[1]}`, minutes: '59' });
      const appointment = filteredMovie.schedule.filter((filteredShowTime) => {
        const actualShow = moment({ hours: filteredShowTime.playtime.split(':')[0], minutes: filteredShowTime.playtime.split(':')[1] });
        if (+filteredShowTime.playtime.split(':')[0].split('')[0] === 0 && time.split('-')[0] === '22') {
          return moment(actualShow).isBetween(moment({ hours: '00', minutes: '00' }), secondHour, null, '[]');
        }
        if (time.split('-')[0] === '22' && +filteredShowTime.playtime.split(':')[0] >= 22) {
          return moment(actualShow).isBetween(firstHour, moment({ hours: '23', minutes: '59' }), null, '[]');
        }
        return moment(actualShow).isBetween(firstHour, secondHour, null, '[]');
      });
      if (appointment.length > 0) {
        return appointment;
      }
      return '';
    }),
  }))
  : []);

const premiere = ['premier előtt', 'premier', ''];
const orderOfPremiere = movie => premiere.indexOf(movie.schedule[0].cinemas[0].premiere.toLowerCase());
const createAttribute = (actualMovies, attribute) => actualMovies
  .map(film => _.uniq(film.schedule.map(sche => sche.cinemas.map(cin => cin[attribute])).flat(1)));

const appReducer = (state = initialState, action) => {
  moment.locale('hu');
  switch (action.type) {
    case SET_BRAND: {
      const { brand } = action.payload;
      return {
        ...state,
        brand: brand === null ? 0 : +brand,
        selectedCinema: brand === null ? 0 : +brand,
      };
    }

    case SELECT_CINEMA: {
      const { cinema } = action.payload;
      const actualWeek = state.weeksDetails.find(weekDetail => +weekDetail.week === +state.selectedWeek);
      const actualDate = actualWeek.schedule.find(schedule => schedule.date === state.selectedDate);
      let actualMovies = cinema !== 0 ? actualDate.movies
        .filter(movie => movie.schedule.some(schedule => (schedule.cinemas.find(cinemaId => cinemaId.id === cinema)),
        )).map(movie => ({
          ...movie,
          schedule: movie.schedule.filter(schedule => schedule.cinemas.some(currCinema => currCinema.id === cinema))
            .map(currentSchedule => ({
              ...currentSchedule,
              cinemas: currentSchedule.cinemas.filter(currentCinema => currentCinema.id === cinema),
            })),
        })) : actualDate.movies;
      actualMovies = actualMovies.map((film, index) => ({
        ...film,
        dubSubs: createAttribute(actualMovies, 'dubSub')[index],
        dubSubCodes: createAttribute(actualMovies, 'dubSubCode')[index],
        visualEffects: createAttribute(actualMovies, 'visualEffect')[index],
      }));
      const searchedMovies = state.searchField !== ''
        ? state.movies.filter(actualMovie => actualMovie.title.toUpperCase().includes(state.searchField.toUpperCase())) : state.movies;
      const filteredMovies = actualMovies
        .filter(filteredMovie => searchedMovies.find(searchedMovie => searchedMovie.id.toString() === filteredMovie.movieId))
        .sort((curr, next) => {
          if(orderOfPremiere(curr) > orderOfPremiere(next)) return 1;
          if(orderOfPremiere(curr) < orderOfPremiere(next)) return -1;
          return [normalizeTitle(curr), normalizeTitle(next)].sort().indexOf(normalizeTitle(curr).normalize('NFD').replace(/[\u0300-\u036f]/g, '')) - 1;
        });
      return {
        ...state,
        selectedCinema: +cinema,
        filteredMovies,
        realTableData: createTable(filteredMovies, state),
      };
    }

    case SELECT_WEEK: {
      const { week } = action.payload;
      return {
        ...state,
        selectedWeek: week,
      };
    }

    case CHANGE_DATE: {
      const actualWeek = state.weeksDetails.find(weekDetail => +weekDetail.week === +state.selectedWeek);
      const actualDates = actualWeek.schedule.map(dates => dates.date);
      const findDate = actualDates.find(date => date === moment().format('YYYYMMDD'));
      let selectedDateIndex = -1;
      let selectedDate = findDate || actualDates[selectedDateIndex];
      const getActualMovies = () => {
        let films = [];
        while (films.length < 1 && selectedDateIndex !== actualDates.length - 1) {
          selectedDateIndex += 1;
          selectedDate = findDate || actualDates[selectedDateIndex];
          const actualDate = actualWeek.schedule.find(schedule => schedule.date === selectedDate);  // eslint-disable-line
          films = state.selectedCinema !== 0 ? actualDate.movies
            .filter(movie => movie.schedule.some(schedule => (schedule.cinemas.find(cinemaId => cinemaId.id === state.selectedCinema)),
            )).map(movie => ({
              ...movie,
              schedule: movie.schedule.filter(schedule => schedule.cinemas.some(currCinema => currCinema.id === state.selectedCinema))
                .map(currentSchedule => ({
                  ...currentSchedule,
                  cinemas: currentSchedule.cinemas.filter(currentCinema => currentCinema.id === state.selectedCinema),
                })),
            })) : actualDate.movies;
        }
        return films;
      };
      let actualMovies = getActualMovies();
      actualMovies = actualMovies.map((film, index) => ({
        ...film,
        dubSubs: createAttribute(actualMovies, 'dubSub')[index],
        dubSubCodes: createAttribute(actualMovies, 'dubSubCode')[index],
        visualEffects: createAttribute(actualMovies, 'visualEffect')[index],
      }));
      const searchedMovies = state.searchField !== ''
        ? state.movies.filter(actualMovie => actualMovie.title.toUpperCase().includes(state.searchField.toUpperCase())) : state.movies;
      const filteredMovies = actualMovies
        .filter(filteredMovie => searchedMovies.find(searchedMovie => searchedMovie.id.toString() === filteredMovie.movieId))
        .sort((curr, next) => {
          if(orderOfPremiere(curr) > orderOfPremiere(next)) return 1;
          if(orderOfPremiere(curr) < orderOfPremiere(next)) return -1;
          return [normalizeTitle(curr), normalizeTitle(next)].sort().indexOf(normalizeTitle(curr)) - 1;
        });
      return {
        ...state,
        selectedDate: findDate || actualDates[selectedDateIndex],
        dates: actualDates.map(date => ({
          dateId: date,
          date: moment(date).format('MMM. DD'),
          day: date === moment().format('YYYYMMDD') ? 'Ma' : moment(date).format('dddd'),
          disabledDate: date !== moment().format('YYYYMMDD') && moment(date).isBefore(moment()),
        })),
        filteredMovies,
        realTableData: createTable(filteredMovies, state),
      };
    }

    case SELECT_DATE: {
      const { date } = action.payload;
      const actualWeek = state.weeksDetails.find(weekDetail => +weekDetail.week === +state.selectedWeek);
      const actualDate = actualWeek.schedule.find(schedule => schedule.date === date);
      let actualMovies = state.selectedCinema !== 0 ? actualDate.movies
        .filter(movie => movie.schedule.some(schedule => (schedule.cinemas.find(cinemaId => cinemaId.id === state.selectedCinema)),
        )).map(movie => ({
          ...movie,
          schedule: movie.schedule.filter(schedule => schedule.cinemas.some(currCinema => currCinema.id === state.selectedCinema))
            .map(currentSchedule => ({
              ...currentSchedule,
              cinemas: currentSchedule.cinemas.filter(currentCinema => currentCinema.id === state.selectedCinema),
            })),
        })) : actualDate.movies;
      actualMovies = actualMovies.map((film, index) => ({
        ...film,
        dubSubs: createAttribute(actualMovies, 'dubSub')[index],
        dubSubCodes: createAttribute(actualMovies, 'dubSubCode')[index],
        visualEffects: createAttribute(actualMovies, 'visualEffect')[index],
      }));
      const searchedMovies = state.searchField !== ''
        ? state.movies.filter(actualMovie => actualMovie.title.toUpperCase().includes(state.searchField.toUpperCase())) : state.movies;
      const filteredMovies = actualMovies.filter(filteredMovie => searchedMovies.find(searchedMovie => searchedMovie.id.toString() === filteredMovie.movieId))
        .sort((curr, next) => {
          if(orderOfPremiere(curr) > orderOfPremiere(next)) return 1;
          if(orderOfPremiere(curr) < orderOfPremiere(next)) return -1;
          return [normalizeTitle(curr), normalizeTitle(next)].sort().indexOf(normalizeTitle(curr)) - 1;
        });
      return {
        ...state,
        selectedDate: date,
        filteredMovies,
        realTableData: createTable(filteredMovies, state),
      };
    }

    case SEARCH_MOVIE: {
      const { movie } = action.payload;
      const actualWeek = state.weeksDetails.find(weekDetail => +weekDetail.week === +state.selectedWeek);
      const actualDate = actualWeek.schedule.find(schedule => schedule.date === state.selectedDate);
      let actualMovies = state.selectedCinema !== 0 ? actualDate.movies
        .filter(actualMovie => actualMovie.schedule.some(schedule => (schedule.cinemas.find(cinemaId => cinemaId.id === state.selectedCinema)),
        )).map(film => ({
          ...film,
          schedule: film.schedule.filter(schedule => schedule.cinemas.some(currCinema => currCinema.id === state.selectedCinema))
            .map(currentSchedule => ({
              ...currentSchedule,
              cinemas: currentSchedule.cinemas.filter(currentCinema => currentCinema.id === state.selectedCinema),
            })),
        })) : actualDate.movies;
      actualMovies = actualMovies.map((film, index) => ({
        ...film,
        dubSubs: createAttribute(actualMovies, 'dubSub')[index],
        dubSubCodes: createAttribute(actualMovies, 'dubSubCode')[index],
        visualEffects: createAttribute(actualMovies, 'visualEffect')[index],
      }));
      const searchedMovies = movie !== '' ? state.movies.filter(actualMovie => actualMovie.title.toUpperCase().includes(movie.toUpperCase())) : state.movies;
      const filteredMovies = actualMovies
        .filter(filteredMovie => searchedMovies.find(searchedMovie => searchedMovie.id.toString() === filteredMovie.movieId))
        .sort((curr, next) => {
          if(orderOfPremiere(curr) > orderOfPremiere(next)) return 1;
          if(orderOfPremiere(curr) < orderOfPremiere(next)) return -1;
          return [normalizeTitle(curr), normalizeTitle(next)].sort().indexOf(normalizeTitle(curr)) - 1;
        });
      return {
        ...state,
        searchField: movie,
        filteredMovies,
        realTableData: createTable(filteredMovies, state),
      };
    }

    case WEEKS_AND_CINEMAS_SUCCEDED: {
      const { weeks, cinemas } = action.payload;
      const appCinemas = Object.keys(cinemas).map(id => ({
        ...cinemas[id],
        id: +id,
        weight: +cinemas[id].weight,
      }));
      const sortedCinemas = appCinemas.sort((a, b) => a.weight - b.weight);
      const brandCinema = appCinemas.find(appCinema => appCinema.id === +state.brand);
      return {
        ...state,
        weeks: weeks.map(week => +week),
        cinemas: sortedCinemas,
        selectedWeek: state.selectedWeek || +weeks[0],
        brandClass: brandCinema ? `react-${brandCinema.logo}` : 'react-artmozi',
        brand: brandCinema === undefined ? 0 : +state.brand,
        selectedCinema: brandCinema === undefined ? 0 : +state.selectedCinema,
      };
    }

    case WEEK_DETAILS_REQUESTED: {
      return {
        ...state,
        dates: state.dates ? state.dates.map(date => ({
          ...date,
          disabledDate: true,
        })) : [],
        isRequested: true,
      };
    }

    case WEEK_DETAILS_SUCCEDED: {
      const { week, movies, schedule } = action.payload;
      const movieDetails = movies;
      const findDate = Object.keys(schedule).find(date => date === moment().format('YYYYMMDD'));
      let selectedDateIndex = -1;
      let selectedDate = findDate || Object.keys(schedule)[selectedDateIndex];
      const getActualMovies = () => {
        let films = [];
        let cinemaFilteredMovies = [];
        while ((films.length < 1 || cinemaFilteredMovies.length < 1) && Object.keys(schedule).length - 1 !== selectedDateIndex) {
          selectedDateIndex += 1;
          selectedDate = findDate || Object.keys(schedule)[selectedDateIndex];
          films = Object.keys(schedule[selectedDate]).map(movie => ({ // eslint-disable-line
            movieId: movie,
            ...movieDetails[movie],
            schedule: Object.keys(schedule[selectedDate][movie]).map(playtime => ({
              playtime,
              cinemas: Object.keys(schedule[selectedDate][movie][playtime])
                .map(key => ({
                  ...state.cinemas.find(cin => cin.id === schedule[selectedDate][movie][playtime][key].cinema),
                  ...schedule[selectedDate][movie][playtime][key],
                })),
            })),
            dubSubs: _.uniq(Object.keys(schedule[selectedDate][movie]).map(playtime => (
              Object.keys(schedule[selectedDate][movie][playtime]).map(key => (
                schedule[selectedDate][movie][playtime][key].dubSub
              ))
            )).flat(1)),
            dubSubCodes: _.uniq(Object.keys(schedule[selectedDate][movie]).map(playtime => (
              Object.keys(schedule[selectedDate][movie][playtime]).map(key => (
                schedule[selectedDate][movie][playtime][key].dubSubCode
              ))
            )).flat(1)),
            visualEffects: _.uniq(Object.keys(schedule[selectedDate][movie]).map(playtime => (
              Object.keys(schedule[selectedDate][movie][playtime]).map(key => (
                schedule[selectedDate][movie][playtime][key].visualEffect
              ))
            )).flat(1)),
          }));
          cinemaFilteredMovies = state.selectedCinema !== 0 && films.length > 0 ? films
            .filter(movie => movie.schedule.some(currSchedule => (currSchedule.cinemas.find(cinemaId => cinemaId.id === state.selectedCinema)),
            )).map(movie => ({
              ...movie,
              schedule: movie.schedule.filter(movieSchedule => movieSchedule.cinemas.some(currCinema => currCinema.id === state.selectedCinema))
                .map(currentSchedule => ({
                  ...currentSchedule,
                  cinemas: currentSchedule.cinemas.filter(currentCinema => currentCinema.id === state.selectedCinema),
                })),
            })) : films;
          cinemaFilteredMovies = cinemaFilteredMovies.length > 0 ? cinemaFilteredMovies.map((film, index) => ({ // eslint-disable-line
            ...film,
            dubSubs: createAttribute(cinemaFilteredMovies, 'dubSub')[index],
            dubSubCodes: createAttribute(cinemaFilteredMovies, 'dubSubCode')[index],
            visualEffects: createAttribute(cinemaFilteredMovies, 'visualEffect')[index],
          })) : cinemaFilteredMovies;
        }
        return cinemaFilteredMovies;
      };
      const cinemaFilteredMovies = getActualMovies();
      const searchedMovies = state.searchField !== ''
        ? state.movies.filter(actualMovie => actualMovie.title.toUpperCase().includes(state.searchField.toUpperCase()))
        : Object.keys(movies).map(id => ({
          ...movies[id],
          id: +id,
        }));
      const filteredMovies = cinemaFilteredMovies
        .filter(filteredMovie => searchedMovies.find(searchedMovie => searchedMovie.id.toString() === filteredMovie.movieId))
        .sort((curr, next) => {
          if(orderOfPremiere(curr) > orderOfPremiere(next)) return 1;
          if(orderOfPremiere(curr) < orderOfPremiere(next)) return -1;
          return [normalizeTitle(curr), normalizeTitle(next)].sort().indexOf(normalizeTitle(curr)) - 1;
        });
      return {
        ...state,
        isRequested: false,
        weeksDetails: [
          ...state.weeksDetails,
          {
            week,
            schedule: Object.keys(schedule).map(date => ({
              date,
              movies: Object.keys(schedule[date]).map(movie => ({
                movieId: movie,
                ...movieDetails[movie],
                schedule: Object.keys(schedule[date][movie]).map(playtime => ({
                  playtime,
                  cinemas: Object.keys(schedule[date][movie][playtime])
                    .map(key => ({
                      ...state.cinemas.find(cin => cin.id === schedule[date][movie][playtime][key].cinema),
                      ...schedule[date][movie][playtime][key],
                    })),
                })),
                dubSubs: _.uniq(Object.keys(schedule[date][movie]).map(playtime => (
                  Object.keys(schedule[date][movie][playtime]).map(key => (
                    schedule[date][movie][playtime][key].dubSub
                  ))
                )).flat(1)),
                dubSubCodes: _.uniq(Object.keys(schedule[date][movie]).map(playtime => (
                  Object.keys(schedule[date][movie][playtime]).map(key => (
                    schedule[date][movie][playtime][key].dubSubCode
                  ))
                )).flat(1)),
                visualEffects: _.uniq(Object.keys(schedule[date][movie]).map(playtime => (
                  Object.keys(schedule[date][movie][playtime]).map(key => (
                    schedule[date][movie][playtime][key].visualEffect
                  ))
                )).flat(1)),
              })),
            })),
          },
        ],
        movies: state.movies.concat(Object.keys(movies).map(id => ({
          ...movies[id],
          id: +id,
        }))),
        dates: Object.keys(schedule).map(date => ({
          dateId: date,
          date: moment(date).format('MMM. DD'),
          day: date === moment().format('YYYYMMDD') ? 'Ma' : moment(date).format('dddd'),
          disabledDate: date !== moment().format('YYYYMMDD') && moment(date).isBefore(moment()),
        })),
        selectedDate: findDate || Object.keys(schedule)[selectedDateIndex],
        filteredMovies,
        realTableData: createTable(filteredMovies, state),
      };
    }

    case SELECT_VIEW: {
      const { view } = action.payload;
      return {
        ...state,
        selectedView: view,
        realTableData: createTable(state.filteredMovies, state),
      };
    }

    case TABLE_REQUESTED: {
      return {
        ...state,
        realTableData: createTable(state.filteredMovies, state),
      };
    }

    case OPEN_MODAL: {
      const { activeModal } = state;
      const { modalData } = action.payload;
      const newState = (activeModal.title === modalData.title && activeModal.playtime === modalData.playtime)
        ? {
          title: null,
          playtime: null,
        }
        : {
          title: modalData.title,
          playtime: modalData.playtime,
        };

      return {
        ...state,
        activeModal: {
          ...newState,
        },
      };
    }

    case GET_CURRENT_TIME: {
      return {
        ...state,
        currentTime: {
          ...state.currentTime,
          dateNowIndex: state.timeList.findIndex(time => time.includes(new Date().getHours())),
          hours: new Date().getHours(),
          minutes: new Date().getMinutes(),
        },
      };
    }

    case CLOSE_MODAL: {
      return {
        ...state,
        activeModal: {
          title: null,
          index: null,
        },
      };
    }

    case REMOVE_SEARCH_FIELD: {
      const actualWeek = state.weeksDetails.find(weekDetail => +weekDetail.week === +state.selectedWeek);
      const actualDate = actualWeek.schedule.find(schedule => schedule.date === state.selectedDate);
      let actualMovies = state.selectedCinema !== 0 ? actualDate.movies
        .filter(movie => movie.schedule.some(schedule => (schedule.cinemas.find(cinemaId => cinemaId.id === state.selectedCinema)),
        )).map(movie => ({
          ...movie,
          schedule: movie.schedule.filter(schedule => schedule.cinemas.some(currCinema => currCinema.id === state.selectedCinema))
            .map(currentSchedule => ({
              ...currentSchedule,
              cinemas: currentSchedule.cinemas.filter(currentCinema => currentCinema.id === state.selectedCinema),
            })),
        })) : actualDate.movies;
      actualMovies = actualMovies.map((film, index) => ({
        ...film,
        dubSubs: createAttribute(actualMovies, 'dubSub')[index],
        dubSubCodes: createAttribute(actualMovies, 'dubSubCode')[index],
        visualEffects: createAttribute(actualMovies, 'visualEffect')[index],
      }));
      const filteredMovies = actualMovies
        .filter(filteredMovie => state.movies.find(searchedMovie => searchedMovie.id.toString() === filteredMovie.movieId))
        .sort((curr, next) => {
          if(orderOfPremiere(curr) > orderOfPremiere(next)) return 1;
          if(orderOfPremiere(curr) < orderOfPremiere(next)) return -1;
          return [normalizeTitle(curr), normalizeTitle(next)].sort().indexOf(normalizeTitle(curr)) - 1;
        });
      return {
        ...state,
        searchField: '',
        filteredMovies,
        realTableData: createTable(filteredMovies, state),
      };
    }

    default:
      return state;
  }
};

export default appReducer;
